import type { ComponentPropsWithRef } from "react";

import { cn } from "@intergamma/common/cn";

export function Info({ className, ...props }: ComponentPropsWithRef<"svg">) {
  return (
    <>
      <svg
        className={cn("karwei:hidden", className)}
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M12 17.296C11.5582 17.296 11.2 16.9378 11.2 16.496V10.496C11.2 10.0542 11.5582 9.69599 12 9.69599C12.4419 9.69599 12.8 10.0542 12.8 10.496V16.496C12.8 16.9378 12.4419 17.296 12 17.296Z"
          fill="currentColor"
        />
        <path
          d="M11.2 7.496C11.2 7.93783 11.5582 8.296 12 8.296C12.4418 8.296 12.8 7.93783 12.8 7.496V7.4C12.8 6.95817 12.4418 6.6 12 6.6C11.5582 6.6 11.2 6.95817 11.2 7.4V7.496Z"
          fill="currentColor"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M1.25 12C1.25 6.06294 6.06294 1.25 12 1.25C17.9371 1.25 22.75 6.06294 22.75 12C22.75 17.9371 17.9371 22.75 12 22.75C6.06294 22.75 1.25 17.9371 1.25 12ZM12 2.75C6.89137 2.75 2.75 6.89137 2.75 12C2.75 17.1086 6.89137 21.25 12 21.25C17.1086 21.25 21.25 17.1086 21.25 12C21.25 6.89137 17.1086 2.75 12 2.75Z"
          fill="currentColor"
        />
      </svg>
      <svg
        className={cn("gamma:hidden", className)}
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0ZM0.909091 10C0.909091 4.97923 4.97923 0.909091 10 0.909091C15.0208 0.909091 19.0909 4.97923 19.0909 10C19.0909 15.0208 15.0208 19.0909 10 19.0909C4.97923 19.0909 0.909091 15.0208 0.909091 10Z"
          fill="currentColor"
        />
        <path
          d="M9.25781 5.25H10.7559V6.7758H9.25781V5.25Z"
          fill="currentColor"
        />
        <path
          d="M9.24414 14.746V8.73819H10.7559V14.746H9.24414Z"
          fill="currentColor"
        />
      </svg>
    </>
  );
}
